import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import {
  fade, withStyles, Menu, Button, MenuItem, Box, LinearProgress, Typography
} from '@material-ui/core'
import { InvoicesListingConsumer, InvoicesListingProvider } from '../../context/InvoicesListingContext'
import { singleInvoiceStyles } from './Styles'
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined'
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined'
import CodeIcon from '@material-ui/icons/Code'
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined'
import PublicIcon from '@material-ui/icons/Public'
import BlockOutlinedIcon from '@material-ui/icons/BlockOutlined'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import { InvoiceViewConsumer } from '../../context/InvoiceViewContext'
import AddNewDialog from '../Dialog/AddNewDialog'
import AddNewForm from '../../FormFields/EntityAddForm'
import { FormLoader } from '../Loader/FormLoader'
import { useStyles } from '../InvoicesHelpers/TableWithFilter/Styles'
import moment from 'moment'
import Configuration from '../../Services/Api/Configuration'
import { AuthConsumer, AuthContext } from '../../context/AuthContext'
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'

const SingleInvoiceActions = ({ status, id, msId, isSubmitted, userPermissions, invoiceData, locale, isMs = false }) => {
  const classes = singleInvoiceStyles()
  const progressClasses = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [isMenuView, setIsMenuView] = React.useState(false)
  const { taxpayerSubscriptionsData, taxpayerData } = useContext(AuthContext)
  const isMenuOpen = Boolean(anchorEl)
  const menuId = 'header-account-menu'
  const StyledMenu = withStyles((theme) => ({
    paper: {
      borderRadius: theme.spacing(0),
      boxShadow: `0 8px 16px -4px ${fade(theme.palette.common.white, 0.16)}`,
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(0),
      textAlign: 'left',
      '& .MuiMenu-list': {
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // width: 220,
        border: `1px solid ${theme.palette.colors.border}`
      }
    }
  }))((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: locale === 'ar' ? 'left' : 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: locale === 'ar' ? 'left' : 'right'
      }}
      {...props}
    />
  ))


  const handleProfileMenuOpen = (event) => {
    setIsMenuView(true)
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
    setTimeout(() => setIsMenuView(false), 300)
  }

  const getCurrentUserActions = () => {
    let actions = []
    if (status?.status && !isMs) {
      actions = !!userPermissions?.includes(Configuration.permissions.invoice.view) ? [{
        name: 'download',
        icon: <CloudDownloadIcon />,
        children: [
          {
            name: 'download-json',
            icon: <InsertDriveFileOutlinedIcon />
          }, {
            name: 'download-xml',
            icon: <CodeIcon />
          }
        ]
      }] : []
    }
    if (status?.status && isMs) {
      actions = !!userPermissions?.includes(Configuration.permissions.invoice.view) ? [{
        name: 'download',
        icon: <CloudDownloadIcon />,
        children: [
          {
            name: 'download-pdf',
            icon: <PictureAsPdfOutlinedIcon />
          }, {
            name: 'download-json',
            icon: <InsertDriveFileOutlinedIcon />
          }, {
            name: 'download-xml',
            icon: <CodeIcon />
          }
        ]
      }
      ] : []
      if (!!isSubmitted) {
        switch (status?.status) {
          case 'Valid':
            let declineReject = (!!userPermissions?.includes(Configuration.permissions.invoice.declineReject) && moment(status?.canbeRejectedUntil).diff(moment(), 'seconds') >= 0) ?
              ((!!status?.rejectRequestDate && !!status?.rejectRequestDelayedDate) ? [{
                name: 'decline-reject',
                icon: <DeleteForeverOutlinedIcon />
              }] : []) : []
            let cancel = (!!userPermissions?.includes(Configuration.permissions.invoice.cancel) && moment(status?.canbeCancelledUntil).diff(moment(), 'seconds') >= 0) ?
              ((!status?.cancelRequestDate && !status?.rejectRequestDate) ? [{
                name: 'cancel',
                icon: <DeleteForeverOutlinedIcon />
              }] : []) : []
            let copy = (['i', 'c', 'd', 'ei', 'ec', 'ed'].includes(invoiceData?.general?.documentType?.toLowerCase()) && !!taxpayerSubscriptionsData?.hasQuota) ?
              [{
                name: 'create-copy',
                icon: <DescriptionOutlinedIcon />
              }] : []
            let creditDebit = (['i', 'ei'].includes(invoiceData?.general?.documentType?.toLowerCase()) && (!invoiceData?.status?.cancelRequestDate && !invoiceData?.status?.rejectRequestDate) && !invoiceData?.freeze) ?
              [{
                name: 'create-credit-note',
                icon: <DescriptionOutlinedIcon />
              },
              {
                name: 'create-debit-note',
                icon: <DescriptionOutlinedIcon />
              }] : []
            actions = [
              ...declineReject,
              ...cancel,
              ...copy,
              ...creditDebit,
              {
                name: 'print',
                icon: <PrintOutlinedIcon />
              },
              {
                name: 'get-public-link',
                icon: <PublicIcon />
              }, ...actions
            ]
            break
          default:
            break
        }
      } else {
        switch (status?.status) {
          case 'Valid':
            let declineCancel = (!!userPermissions?.includes(Configuration.permissions.invoice.declineCancel) && moment(status?.canbeCancelledUntil).diff(moment(), 'seconds') >= 0) ?
              ((!!status?.cancelRequestDate && !!status?.cancelRequestDelayedDate) ? [{
                name: 'decline-cancel',
                icon: <DeleteForeverOutlinedIcon />
              }] : []) : []
            let reject = (!!userPermissions?.includes(Configuration.permissions.invoice.reject) && moment(status?.canbeRejectedUntil).diff(moment(), 'seconds') >= 0) ?
              ((!status?.cancelRequestDate && !status?.rejectRequestDate) ? [{
                name: 'reject',
                icon: <BlockOutlinedIcon />
              }] : []) : []
            actions = [
              ...declineCancel,
              ...reject,
              {
                name: 'print',
                icon: <PrintOutlinedIcon />
              },
              {
                name: 'get-public-link',
                icon: <PublicIcon />
              }, ...actions
            ]
            break
          default:
            break
        }
      }
    }
    return actions
  }

  let userActions = getCurrentUserActions()
  return (
    <AuthConsumer>
      {({ taxpayerSubscriptionsData }) => (
        <InvoiceViewConsumer>
          {({ getInvoiceData, getMsInvoiceData }) => (
            <InvoicesListingProvider isSingle={true} loadSingle={!!isMs ? getMsInvoiceData : getInvoiceData} isMs={isMs}
              hasSubscription={!!taxpayerSubscriptionsData?.hasValidSubscription}>
              <InvoicesListingConsumer>
                {({ openDialog, currentDialogAction, currentSelectedRow, dialogActionSubmit, cancelDialog, isDialogOpen, downloadLoading, downloadLoadingProgress }) => (
                  <>

                    <AddNewDialog
                      children={<AddNewForm entityName={`invoicesActions-${currentDialogAction}`}
                        currentData={currentSelectedRow}
                        onSubmit={dialogActionSubmit}
                        currentAction={currentDialogAction}
                        cancelDialog={cancelDialog} />}
                      dialogAction={currentDialogAction}
                      DialogTitle={<FormattedMessage
                        id={`invoicesActions.dialogTitle.${currentDialogAction}`}
                        values={{ name: currentSelectedRow?.uuid || '' }} />}
                      isDialogOpen={isDialogOpen}
                      cancelDialog={cancelDialog}
                    />
                    {!!downloadLoading && <>
                      <FormLoader loading={true} />
                      <div className={progressClasses.downloadProgressWrapper}>
                        <Box display="flex" alignItems="center" className={progressClasses.progress}>
                          <Box width="100%" mr={1}>
                            <LinearProgress color={'primary'} variant="determinate" value={downloadLoadingProgress} />
                          </Box>
                          <Box minWidth={35}>
                            <Typography variant="body2"
                              color="primary">{`${downloadLoadingProgress}%`}</Typography>
                          </Box>
                        </Box>
                      </div>
                    </>}

                    {!!userActions?.length && userActions.map((actionData, index) => (
                      <React.Fragment key={index}>
                        <Button
                          onClick={(event) => actionData?.children?.length ? handleProfileMenuOpen(event) : openDialog(actionData.name, status, id, handleMenuClose, msId, isMs)}
                          className={classes.buttonAction + ` ${actionData.name}`} disableElevation disableRipple>
                          {actionData.icon}
                          <FormattedMessage id={`InvoicesActionsMenu.button.${actionData.name}`}
                            values={{
                              strong: chunks => <strong>{chunks}</strong>
                            }} />
                        </Button>

                        {!!actionData?.children?.length && !!isMenuView &&
                          <StyledMenu
                            id={menuId}
                            anchorEl={anchorEl}
                            keepMounted
                            open={isMenuOpen}
                            onClose={handleMenuClose}
                          >
                            {!!actionData?.children?.length && actionData?.children?.map((child, childIndex) => (
                              !(status?.MSStatus === 'Invalid' && child.name === 'download-pdf') &&
                              <MenuItem
                                key={`${index}-${childIndex}`}
                                onClick={() => openDialog(child.name, status, id, handleMenuClose, msId, isMs)}
                                className={classes.buttonAction + ` inner ${child.name}`}>
                                {child.icon}
                                <FormattedMessage id={`InvoicesActionsMenu.button.${child.name}`}
                                  values={{
                                    strong: chunks => <strong>{chunks}</strong>
                                  }} />
                              </MenuItem>
                            ))}
                          </StyledMenu>
                        }

                      </React.Fragment>
                    ))}
                  </>
                )}
              </InvoicesListingConsumer>
            </InvoicesListingProvider>
          )}
        </InvoiceViewConsumer>
      )}
    </AuthConsumer>
  )
}

export default SingleInvoiceActions
